import {h, Fragment} from "preact"
import { useFacets } from "@nosto/preact"
import { useEffect, useMemo, useState, useRef } from "preact/hooks"
import { nativePopularFilters, updateFacetsWithFilterTemplate } from "../../config"

import FilterDropdownList from "./FilterDropdownList"

export default function DesktopPopularFilters({ filters }) {
    let { facets } = useFacets();
    const [ activeDropdown, setActiveDropdown ] = useState(null);
    const containerRef = useRef(null);

    useEffect(() => {
        //2025-07-02 Localized event listener
        const node = containerRef.current;
        if (!node) return;
        const handleClick = (event) => {
            if (!node.contains(event.target)) setActiveDropdown(null);
        };
        node.addEventListener("click", handleClick);
        return () => node.removeEventListener("click", handleClick);
    }, []);

    const handleDropdownChange = (id) => {
        setActiveDropdown(id !== activeDropdown ? id : null)
    }

    let finalFacets = nativePopularFilters;

    let filterTemplateFacets = document.getElementById('filter-template-data') ?? null;
    if(filterTemplateFacets) {
        let newFilters = JSON.parse(filterTemplateFacets.dataset.filterTemplate);
        if(newFilters.featured_filters != undefined) {
            finalFacets = newFilters.featured_filters;
        }
    }

    if(!finalFacets.length) return (<></>)
    
    return (
        <div class="hidden lg:inline-flex max-w-[60vw]">
            <div class="border-l pl-xs pt-xs pb-xs body-14 border-t-ui-lines-2">Popular Filters:</div>
            <form
                class="pl-xs"
                onSubmit={e => e.preventDefault()}
            >
                <div class="flex flex-wrap gap-xs text-t-foreground bg-t-background" ref={containerRef}>
                    {finalFacets.map(facetName => {;
                        const matchingFacet = facets.find(f => f.name.toLowerCase() === facetName.toLowerCase());
                        if(!matchingFacet) return null;
                        return (
                            <div class="ns-popular-dropdown relative js-filter border border-t-border-primary px-xs group/filter-dropdown cursor-pointer h-10 flex items-center bg-t-background open:bg-p-lightest">
                                <button 
                                    type="button" 
                                    class="ns-popular-toggle focus-inset flow-root h-full"
                                    id={`ns-filter-toggle-${matchingFacet.id}`} 
                                    aria-expanded={activeDropdown === matchingFacet.id}
                                    aria-controls={`ns-dropdown-panel-${matchingFacet.id}`}
                                    onClick={() => setActiveDropdown(activeDropdown === matchingFacet.id ? null : matchingFacet.id)}
                                >
                                    <div class="flex w-full h-full items-center justify-between">
                                        <span class="body-14 whitespace-nowrap">{matchingFacet.name}</span>
                                        <span class="ns-chevron-icon ml-sm flex items-center cursor-pointer text-t-brand-primary">
                                            <span class="transition-rotate block w-full h-full">
                                                <span class="block h-full w-full">
                                                    <svg aria-hidden="true" focusable="false" role="presentation" fill="none" class="icon icon-caret-down" id="icon-caret-down" viewBox="0 0 12 12">
                                                        <path stroke="currentColor" d="M11.5 3.5 6 8.313.5 3.5"></path>
                                                    </svg>
                                                </span>
                                            </span>
                                        </span>
                                    </div>
                                </button>
                                <div 
                                    class="ns-popular-dropdown-body py-xs px-4 shadow-custom bg-p-lightest min-w-60 z-10"
                                    id={`ns-dropdown-panel-${matchingFacet.id}`}
                                    aria-labelledby={`ns-filter-toggle-${matchingFacet.id}`}
                                    aria-hidden={activeDropdown !== matchingFacet.id}
                                    role="region"
                                >
                                    <FilterDropdownList facet={matchingFacet} />
                                </div>
                            </div>
                        )
                    })}
                </div>
            </form>
        </div>
    )
}
